var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoirHeart1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5824 10.7083C26.5865 12.5676 25.8702 14.3562 24.5838 15.6987C21.6343 18.757 18.7729 21.9457 15.7146 24.8917C15.0126 25.5562 13.8997 25.5321 13.2291 24.8373L4.4143 15.6999C1.74992 12.9376 1.74992 8.47887 4.4143 5.71783C5.04401 5.05687 5.80139 4.53067 6.64052 4.17113C7.47965 3.8116 8.38305 3.62621 9.29596 3.62621C10.2089 3.62621 11.1123 3.8116 11.9514 4.17113C12.7905 4.53067 13.5479 5.05687 14.1776 5.71783L14.499 6.04892L14.8193 5.71783C15.4497 5.05777 16.2072 4.53209 17.0462 4.17243C17.8851 3.81276 18.7881 3.62655 19.7009 3.625C21.5376 3.625 23.2933 4.379 24.5826 5.71783C25.8695 7.0601 26.5862 8.84876 26.5824 10.7083Z",
    fill: "url(#paint0_linear_168_709)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_709",
    x1: 7.5,
    y1: 4,
    x2: 23.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982027,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirHeart1);
export default __webpack_public_path__ + "static/media/iconoir_heart1.77dc7e7b6721ff3843bb27136f120632.svg";
export { ForwardRef as ReactComponent };